// extracted by mini-css-extract-plugin
export default {"participant":"View_participant__guD2y","info":"View_info__IGxVp","spin":"View_spin__HQm-x"};